<template>
  <Component :is="tag" class="jps-code-span" v-if="code">
    <slot :code="code">{{ ls(code?.name) }}</slot>
  </Component>
</template>

<script lang="ts" setup>
const { ls } = useI18n()
const dataStore = useDataStore()

interface Props {
  id: string
  tag?: string
}
const props = withDefaults(defineProps<Props>(), {
  tag: 'span',
})

const code = dataStore.code(props.id)
</script>
